import { TextField } from "@mui/material"
import { useEffect } from "react"
import { useState } from "react"

// forciblyError - принудительная ошибка
const TextFieldValidate = ({ 
	field, label, placeholder, onChangeMy, onBlurMy, forciblyError, setValidate, required = false, inputProps, disabled, ...rest
}) => {

	const [error, setError] = useState('')

	useEffect(() => {
		updateError()
	}, [field.errors, forciblyError, required]) // required - тут була помилка, так як не було перевірки на помилку під час не обовʼязкового поля

	useEffect(() => {
        updateValidate()
    }, [field.isInputValid, error, required])
    // }, [field, error, required])

	const updateValidate = () => {
		if (setValidate) {
            if (
				(field.isInputValid || !required) && !error
			) {
                setValidate(true)
            } else {
                setValidate(false)
            }
        }
	}

	const updateError = () => {
		let errorTemp = ''

		if (forciblyError) { // Если принудительная ошибка, то выводить ее
			errorTemp = forciblyError
		} else if (!required && !field.value) { // Если поле не обязательное и не заполненное, то без ошибки
			errorTemp = ''
		} else if (field && field.errors) {
			const errors = field.errors
			for (const i in errors) {
				if (errors[i]) {
					// console.log('errors[i]', errors[i])
					errorTemp = errors[i]
					break
				}
			}
		}

		setError(errorTemp)
	}

  return (
    <TextField
        label={label}
        placeholder={placeholder}
        size="small"
        onChange={e => {
			if (onChangeMy) {
				onChangeMy(e.target.value)
			} else {
				field.onChange(e.target.value)
			}
		}} 
        onBlur={e => {
			field.onBlur(e)
			if (onBlurMy) {
				onBlurMy(e)
			}
		}}
        value={field.value}
        error={field.isDirty && error ? true : false} // чтобы был текст (цвет) ошибки
        color={ // чтобы был успешный цвет
            field.isDirty && error ? 'error' :
            field.isDirty && !error ? 'success' :  ''
        }
        helperText={ //Текст ошибки
			field.isDirty && error ? error : ''
		}
        focused={field.isDirty ? true : false}
		disabled={disabled}
        InputLabelProps={{
            shrink: true
        }}
        InputProps={inputProps}
		{...rest}
    />
  )
}

export default TextFieldValidate